import { useState, useCallback } from 'react';

// Type definitions for better type safety
export interface DrilldownData {
  metric?: string;
  heading?: string;
  dt?: number;
  g1?: string;
  g2?: string;
  xAxis?: string;
  yAxis?: string;
  type?: string;
  key?: string;
  g1Header?: string;
  g2Header?: string;
  tableHeader?: string;
  isParentRow?: boolean;
  chartValue?: string;
  metricValue?: any;
  deletedTag?: React.ReactNode;
  isG1Deleted?: boolean;
  isG2Deleted?: boolean;
}

export interface DrilldownConfig {
  group?: any;
  metricMapping: Record<string, string>;
}

export const 	useDrilldownState = (config: DrilldownConfig) => {
  const { group, metricMapping } = config || {};
  // const { group_by_1, group_by_2 } = group || {};

  const [drilldownState, setDrilldownState] = useState({
    config: { drilldownHeading: '', type: '', key: '', isParentRow: false },
  });

  const prepareDrilldownState = useCallback(
    (data: DrilldownData) => {
      // Determine group based on data type

      return {
        config: {
          drilldownMetric: metricMapping[data.metric || ''] || data.metric,
          drilldownHeading: data.metric || '',
          dt: data.dt,
          g1: data.g1,
          g2: data.g2,
          xAxis: data.xAxis,
          yAxis: data.yAxis,
          type: data.type,
          key: data.key,
          g1Header: data?.g1Header,
          g2Header: data?.g2Header,
          tableHeader: data?.tableHeader,
          isParentRow: data?.isParentRow,
          chartValue: data?.chartValue,
          metricValue: data?.metricValue,
          deletedTag: data?.deletedTag,
          isG1Deleted: data?.isG1Deleted,
          isG2Deleted: data?.isG2Deleted,
        },
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [group, metricMapping]
  );

  return {
    drilldownState,
    setDrilldownState: (data: DrilldownData) =>
      setDrilldownState(prepareDrilldownState(data)),
  };
};
